import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { getModulesList } from "./modulesList"; // <-- array με title & description
import { useTranslation } from "react-i18next";

import Logo from "../../assets/images/small-logos/automobile.png";
import { Avatar } from "@mui/material";

function ToolLayout() {
  const { t } = useTranslation();
  const modulesList = getModulesList(t);
  return (
    <DashboardLayout>
      {/* Header */}
      <Card>
        <MDBox p={3} lineHeight={1} display="flex" alignItems="center" gap={2}>
          <Avatar
            variant="rounded"
            sx={{
              width: 64,
              height: 64,
              borderRadius: 2,
              p: 1,
              bgcolor: "#1E293B",
            }}
          >
            <img
              src={Logo}
              alt="Flyover - RCM"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Avatar>

          <MDBox>
            <MDTypography variant="h5" fontWeight="medium">
              {t("tool.caseStudyTitle")}
            </MDTypography>
            <MDTypography variant="button" color="text">
              {t("tool.caseStudySubtitle")}
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>

      {/* Content */}
      <Card sx={{ padding: "1rem", marginTop: "1rem" }}>
       



        <MDBox mb={3}>
          <MDTypography variant="h6" fontWeight="medium">
            {t("tool.aboutTitle")}
          </MDTypography>
          <MDTypography variant="body2" color="text">
            {t("tool.aboutBody")}
          </MDTypography>
        </MDBox>

        {/* Modules List */}
        <MDBox>
          <MDTypography variant="h6" fontWeight="medium" mb={2}>
            {t("tool.modulesTitle")}
          </MDTypography>
          <ol
            style={{
              paddingLeft: "24px",
              color: "#ddd",
              fontSize: "1rem",
              fontWeight: 500,
            }}
          >
            {modulesList.map((item, index) => (
              <li key={index} style={{ marginBottom: "1rem" }}>
                <MDTypography variant="h6" fontWeight="medium">
                  {item.title}
                </MDTypography>
                <MDTypography variant="body2" color="text">
                  {item.description}
                </MDTypography>
              </li>
            ))}
          </ol>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default ToolLayout;
